<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">

    <AppHeader/>

    <!-- begin::Body -->
    <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">

      <LeftMenu/>

      <div class="m-grid__item m-grid__item--fluid m-wrapper">

        <div class="m-content">

          <div class="row">
            <div class="col-xl-12">

              <!--Begin::Portlet-->

              <div class="m-portlet m-portlet--rounded m-portlet--bordered m-portlet--head-sm m-portlet--unair"
                   :m-portlet="'true'">
                <form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed">
                  <div class="m-portlet__body">
                    <div class="m-pricing-table-2">
                      <div class="m-pricing-table-2__head">
                        <div class="m-pricing-table-2__title m--font-light">
                          <h3>{{$t('advertise.ContractDirectoryServices')}}</h3>
                          <div class="container mt-4">
                            <p class="mb-0">{{$t('advertise.DirectoryServiceDesc')}}</p>
                          </div>
                        </div>
                      </div>
                      <div class="m-pricing-table-2__content">
                        <div class="m-pricing-table-2__container">
                          <div class="m-pricing-table-2__items row">

                            <div class="m-pricing-table-2__item col-lg-6">
                              <h2 class="m-pricing-table-2__subtitle mb-5">{{$t('advertise.Featured')}}</h2>

                              <div v-bind:class="{ price_container: true, 'active': isFeaturedServiceSelected(1) }" id="Featured">
                                <span class="m-pricing-table-2__price">45</span>
                                <span class="m-pricing-table-2__label">€</span>
                                <div class="m-pricing-table-2__btn mt-0">
                                  <button v-on:click.stop.prevent="selectFeaturedService(1, 45)"
                                          type="button"
                                          class="btn m-btn--pill  btn-primary m-btn--wide m-btn--uppercase m-btn--bolder m-btn--lg"
                                          data-toggle="button"
                                          aria-pressed="false">{{$t('advertise.Contract')}}
                                  </button>
                                </div>
                              </div>


                            </div>

                            <div class="m-pricing-table-2__item col-lg-6">

                              <h2 class="m-pricing-table-2__subtitle mb-5">{{$t('advertise.Premium')}}</h2>

                              <div v-bind:class="{ price_container: true, 'active': isPremiumServiceSelected(1) }" id="Premium">
                                <span class="m-pricing-table-2__price">70</span>
                                <span class="m-pricing-table-2__label">€</span>
                                <div class="m-pricing-table-2__btn mt-0">
                                  <button v-on:click.stop.prevent="selectPremiumService(1, 70)" type="button"
                                          class="btn m-btn--pill  btn-primary m-btn--wide m-btn--uppercase m-btn--bolder m-btn--lg"
                                          data-toggle="button"
                                          aria-pressed="false"
                                          data-ts-price="45"
                                          data-ts-num-prop="1"
                                          data-ts-service="premium">{{$t('advertise.Contract')}}
                                  </button>
                                </div>
                              </div>


                            </div>

                            <div class="col-lg-12 separata d-md-none d-sm-none d-none d-lg-block">&nbsp;</div>

                            <div class="col-lg-12 text-center pt-5" v-if="this.service.Price">
                              <span class="pb-5">
                                <h4>{{ totalText }}</h4>
                              </span>
                              <button @click.stop.prevent="sendForm" class="btn m-btn--pill mt-5 btn-success m-btn--wide btn-block">
                                {{$t('advertise.SendContract')}}
                              </button>
                            </div>
                            <div class="col-lg-12 text-center pt-4 mt-2">
                              <span v-if="this.service.Price" class="d-block d-md-block d-lg-inline ml-lg-4 ">
                                  <i class="la la-asterisk m--icon-font-size-sm5"></i> {{$t('advertise.PricesWithoutVAT')}}
                                </span>
                              <span class="d-block m--icon-font-size-sm4">
                                  {{$t('advertise.ToContractPropertyServicesPleaseGoTo')}} <router-link :to="{ name:
                                  'Advertise'}" class="m-menu__link">{{$t('advertise.ContractPropertyServices')}}</router-link>
                                </span>
                            </div>

                          </div>
                        </div>
                      </div>


                    </div>
                  </div>
                </form>

              </div>

              <!--end: Portlet-->
            </div>
          </div>

        </div>

      </div>
    </div>
    <!-- end:: Body -->

    <!-- BEGIN: Footer -->
    <AppFooter/>
    <!-- END: Footer -->
  </div>
</template>

<script>
  import AppHeader from '@/components/dashboard/common/Header'
  import AppFooter from '@/components/dashboard/common/Footer'
  import LeftMenu from '@/components/dashboard/common/menus/LeftMenu'

  import {clientapi} from '@/interceptors/clientapi'

  import functions from "@/plugins/functions";

  export default {
    data() {
      return {
        service: {},
        user: {}
      }
    },
    mounted() {
      this.user = functions.getUser()
    },
    components: {
      AppFooter,
      AppHeader,
      LeftMenu
    },
    computed: {
      totalText(){
        return this.$t("advertise.TOTAL") + ': ' + this.service.Price + '€*/'+ this.$t("common.month")
      }
    },
    methods: {
      async sendForm() {

        let params = {
          subject: 'New Directory Services Request',
          body: `Directory Services to contract: ${this.service.Type}${this.service.Properties}<br>User: ${this.user.Login}<br>${this.totalText}`
        }

        let response = await clientapi.post('/contact-advertise', params)
        if (response.status === 200) {
          swal({
            title: this.$t("advertise.FormSubmitedTitle"),
            text: this.$t("advertise.FormSubmitedText"),
            type: "success",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          });
        } else {
          let errorCode = response.data.code
          swal({
            title: this.$t('error.AnErrorOccurred'),
            text: this.$t('error.server.'+errorCode),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          })
        }
      },
      selectFeaturedService(properties, priceInEuro) {
        if (this.isFeaturedServiceSelected(properties)) {
          this.service = {}
        } else {
          this.service = { Properties: properties, Type: 'featured', Price: priceInEuro };
        }
      },
      selectPremiumService(properties, priceInEuro) {
        if (this.isPremiumServiceSelected(properties)){
          this.service = {}
        } else {
          this.service = {Properties: properties, Type: 'premium', Price: priceInEuro };
        }
      },
      isFeaturedServiceSelected(properties){
        return this.service.Properties == properties && this.service.Type == 'featured'
      },
      isPremiumServiceSelected(properties){
        return this.service.Properties == properties && this.service.Type == 'premium'
      },
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/dashboard/advertise/AdvertiseDirectory.vue